import React from "react";

const ConfirmationModalRlsMail = ({
  onUpdate,
  onDeleteRls,
  isOpen,
  onClose,
  title,
}) => {
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="relative bg-white p-6 rounded-lg shadow-lg w-[600px] max-w-full">
            {/* Cross button */}
            <button
              className="absolute top-0 right-2 text-gray-600 hover:text-gray-800"
              onClick={onClose}
            >
              <span className="text-2xl">&times;</span> {/* Cross icon */}
            </button>

            {/* Modal Content */}
            <h3 className="text-xl font-semibold text-gray-800 text-center">
              {title}
            </h3>
            <p className="mt-2 text-gray-600 text-center">
              This action cannot be undone.
            </p>
            <div className="mt-4 flex justify-center space-x-3">
              <button
                className="px-3 py-1 text-sm bg-[#E31c23] text-white rounded-md hover:bg-red-600 focus:outline-none transition-colors duration-200 active:bg-[#F87171]"
                onClick={onDeleteRls}
              >
                Update User and Remove RLS and Assigned Reports/Applications
              </button>

              <button
                className="px-3 py-1 text-sm bg-[#E31c23] text-white rounded-md hover:bg-red-600 focus:outline-none transition-colors duration-200 active:bg-[#F87171]"
                onClick={onUpdate}
              >
                Update User and Keep RLS and Assigned Reports/Applications
              </button>

              <button
                className="px-2 py-1 text-sm bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmationModalRlsMail;
